import { ResolveFn, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { ConfigurationService } from '../../../shared/services/configuration.service';

export const revenueManagerResolver: ResolveFn<Observable<any>> = () => {
  const startDate = new Date();
  const endDate = new Date();
  const state = inject(Router).currentNavigation()?.extras.state;
  let criteria: any = {};
  if (state) {
    criteria = { ...state };
    localStorage.setItem('BO-state', JSON.stringify(criteria));
  } else {
    endDate.setDate(endDate.getDate() + 30);
    criteria = {
      filters: {
        ACTIVATION_DATE: [
          startDate.toISOString().replace(/T.*/, '').split('-').join('-'),
          endDate.toISOString().replace(/T.*/, '').split('-').join('-'),
        ],
      },
    };
  }

  return inject(ConfigurationService).getFilters({ ...criteria });
};
